// 进水水质分析
import React from "react";
import * as echarts from "echarts/lib/echarts";
import moment from "moment";

let myChart = null;
class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        id="charts"
        style={{ width: "100%", height: this.props.height }}
      ></div>
    );
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart
      ? echarts.init(document.getElementById("charts"))
      : myChart;
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: {
        type: "category",
        data: ["1月", "2月", "3月", "4月", "5月"],
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "收入",
          type: "bar",
          data: [1000, 1400, 2300, 1000, 1300],
        },
        {
          name: "药耗支出",
          type: "bar",
          data: [150, 100, 200, 140, 140, 100],
        },
        {
          name: "能耗支出",
          type: "bar",
          data: [160, 200, 300, 85, 90, 100],
        },
        {
          name: "人力支出",
          type: "bar",
          data: [300, 100, 200, 160, 140, 120],
        },
        {
          name: "其它支出",
          type: "bar",
          data: [150, 100, 210, 140, 160, 100],
        },
      ],
    };
    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
    myChart.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    myChart = null;
  }
}

export default Charts;
